import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
//
import listeners from './middleware';
import authSlice from './slice/auth.slice';
import { baseApi } from './api/base.api';

export const store = configureStore({
  reducer: {
    // slices
    [authSlice.reducerPath]: authSlice.reducer,
    // API
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware).concat(listeners),
  devTools: {
    actionSanitizer: (action) => {
      if (action.meta?.arg?.endpointName) {
        return {
          ...action,
          type: `${action.type} (${action.meta.arg.endpointName})`,
        };
      }

      return action;
    },
  },
});

setupListeners(store.dispatch);
